import styles from "@/styles/containers/highlights.module.scss";

import Highlights from "./Highlights";

export default function ({ products, onSelectProduct }) {
  return products.length > 0 ? (
    <div className={styles.highlights}>
      <Highlights
        highlights={products}
        onSelectProduct={(product) => onSelectProduct(product)}
      />
    </div>
  ) : null;
}
